import { getToken, getClienteId } from 'utils/auth';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = process.env.REACT_APP_BASE_URL;





const getClienteIdNumber = () => {
  const raw = getClienteId();
  if (!raw || raw === 'null' || raw === 'undefined') return null;
  const n = Number(raw);
  return Number.isNaN(n) ? null : n;
};

// Para querystring: se for null, manda "null" (back trata como IS NULL)
const getClienteIdQuery = () => {
  const id = getClienteIdNumber();
  return id === null ? 'null' : String(id);
};

const sanitizeClientePayload = (fields = {}) => {
  const { complemento, id, ...rest } = fields;
  const payload = { ...rest };

  for (const key of ['estado_id', 'municipio_detran_id']) {
    if (payload[key] === '' || payload[key] == null) {
      payload[key] = null;
    } else {
      const n = Number(payload[key]);
      payload[key] = Number.isNaN(n) ? null : n;
    }
  }

  if (Object.prototype.hasOwnProperty.call(payload, 'ativo')) {
    payload.ativo = payload.ativo === true || payload.ativo === 1 || payload.ativo === '1';
  }

  return payload;
};

export const getApiErrorMessage = (error, fallback = 'Erro na requisição') => {
  const data = error?.data;
  if (typeof data === 'string') return data;
  return data?.message || data?.retorno || data?.mensagem || error?.error || fallback;
};

export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),

  reducerPath: 'adminApi',
  tagTypes: ['AutosInfracao', 'Grv', 'Impressoras', 'DetalhesInfracao', 'GestaoUsuarios', 'GestaoAgentes', 'Orgaos', 'Dispositivos', 'Dispositivo', 'DispositivoBloqueioLogs', 'Equipamentos', 'EquipamentosAfericao', 'Estoque', 'simCartao', 'MedidasAdministrativas', 'Habilitacao', 'Clientes', 'Avisos', 'Importancias', 'ClientesVinculados','Chat', 'VeiculosEmbarcados', 'CondutoresEmbarcados', 'Unidades', 'NotificacoesPainel', 'Operacoes', 'TiposOperacao'],

  endpoints: (build) => ({
    getAutosInfracao: build.query({
      query: ({ page, pageSize, search, cliente_id, status_auto }) => ({
        url: `/auto-infracoes?` +
          `cliente_id=${encodeURIComponent(cliente_id ?? getClienteId() ?? '')}` +
          `&status_auto=${encodeURIComponent(status_auto ?? 1)}` +
          `&page=${encodeURIComponent(page)}` +
          `&pageSize=${encodeURIComponent(pageSize)}` +
          `&search=${encodeURIComponent(search ?? '')}`,
        method: 'GET',
      }),
      providesTags: ['AutosInfracao'],
    }),
    getAutosInfracaoSemVeiculo: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/auto-sem-veiculos?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['AutosInfracao'],
    }),
    getAutosInfracaoEstrangeiros: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/auto-infracoes-estrangeiros?cliente_id=${encodeURIComponent(getClienteId() ?? '')}&page=${encodeURIComponent(page)}&pageSize=${encodeURIComponent(pageSize)}&search=${encodeURIComponent(search ?? '')}`,
        method: 'GET',
      }),
      providesTags: ['AutosInfracao'],
    }),
    getAutuacoesPfPj: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/autuacoes-pf-pj?cliente_id=${encodeURIComponent(getClienteId() ?? '')}&page=${encodeURIComponent(page)}&pageSize=${encodeURIComponent(pageSize)}&search=${encodeURIComponent(search ?? '')}`,
        method: 'GET',
      }),
      providesTags: ['AutosInfracao'],
    }),
    getMedidasAdministrativas: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/auto-infracoes/listar-medidas-administrativas?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['MedidasAdministrativas'],
    }),
    getMunicipios: build.query({
      query: () => ({
        url: `/municipios`,
        method: 'GET',
      }),
      providesTags: ['Municipios'],
    }),
    getStatusAuto: build.query({
      query: () => ({
        url: `/status-autos`,
        method: 'GET',
      }),
      providesTags: ['StatusAuto'],
    }),
    getStatusProcessamento: build.query({
      query: () => ({
        url: `/status-processamentos`,
        method: 'GET',
      }),
      providesTags: ['StatusProcessamento'],
    }),
    confirmarCancelamento: build.mutation({
      query: ({ id, motivo }) => ({
        url: `/auto-infracoes/confirmar-cancelamento/${id}`,
        method: 'PUT',
        body: { motivo },
      }),
      invalidatesTags: ['AutosInfracao', 'AguardandoCancelamento', 'DetalhesInfracao'],
    }),
    anularCancelamento: build.mutation({
      query: ({ id, motivo }) => ({
        url: `/auto-infracoes/anular-cancelamento/${id}`,
        method: 'PUT',
        body: { motivo },
      }),
      invalidatesTags: ['AutosInfracao', 'AguardandoCancelamento', 'DetalhesInfracao'],
    }),
    getListaCancelados: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/auto-infracoes/listar-cancelamentos?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['AutosInfracao'],
    }),
    getListaAguardandoCancelamento: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/auto-infracoes/listar-aguardando-cancelamento?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['AguardandoCancelamento'],
    }),
    getListarFiltro: build.query({
      query: ({ startDate, endDate }) => ({
        url: `/auto-infracoes/autos-filtro?cliente_id=${getClienteId()}&startDate=${startDate}&endDate=${endDate}`,
      }),
      providesTags: ['AutosInfracao'],
    }),
    getDetalhesInfracao: build.query({
      query: (id) => ({
        url: `/auto-infracoes/${id}`,
      }),
      providesTags: (result, error, id) => [{ type: 'DetalhesInfracao', id }],
    }),
    getConveniadosPorOrgao: build.query({
      query: (orgao_id) => ({ // Aceita um argumento orgao_id
        url: `/orgaos-conveniados/listar/${orgao_id}`,
      }),
      providesTags: ['orgaos-conveniados'],
    }),
    getTodosOrgaosDoCliente: build.query({
      query: ({ cliente_id }) => ({
        url: `/orgaos/do-cliente/${cliente_id}`,
      }),
      providesTags: ['orgaos-do-cliente'],
    }),
    getCompetencias: build.query({
      query: () => ({
        url: `/competencias/listar`,
        method: 'GET',
      }),
      providesTags: ['Competencias'],
    }),
    getOrgaosParaAgente: build.query({
      query: ({ agente_id }) => ({
        url: `/orgaos/agente/${agente_id}`,
      }),
      providesTags: (result, error, { orgao_id, agente_id }) => [{ type: 'Conveniados', orgao_id, agente_id }],
    }),
    getOrgaoPorId: build.query({
      query: (id) => ({
        url: `/orgaos/${id}`,
      }),
      providesTags: (result, error, id) => [{ type: 'Orgaos', id }],
    }),
    getOrgaosList: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/orgaos/listar-orgaos?page=${page}&pageSize=${pageSize}&search=${search}`,
      }),
      providesTags: (result, error) => [{ type: 'Conveniados' }],
    }),
    addConveniados: build.mutation({
      query: (fields) => ({
        url: '/orgaos/adicionar',
        method: 'POST',
        body: fields,
      }),
      invalidatesTags: ['Orgaos'],
    }),
    updateOrgao: build.mutation({
      query: ({ id, ...fields }) => ({
        url: `/orgaos/editar/${id}`,
        method: 'PUT',
        body: fields,
      }),
      invalidatesTags: ['Orgaos'],
    }),
    subirLogoOrgao: build.mutation({
      query: ({ id, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/orgaos/subir-logo/${id}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Orgaos'],
    }),
    subirLogoImpressaoOrgao: build.mutation({
      query: ({ id, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/orgaos/subir-logo-impressao/${id}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Orgaos'],
    }),
    subirLogoAITOrgao: build.mutation({
      query: ({ id, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/orgaos/subir-logo-ait/${id}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Orgaos'],
    }),
    getListaFaixa: build.query({
      query: ({ page, pageSize, search, agrupado }) => {
        const qs = new URLSearchParams({
          cliente_id: String(getClienteId()),
          page: String(page),
          pageSize: String(pageSize),
          search: search ?? '',
        });
        if (agrupado) qs.set('agrupado', '1');
        return {
          url: `/faixa-autos/lista-talao?${qs.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['listaFaixa'],
    }),
    getListaReincidencias: build.query({
      query: ({ page, pageSize }) => ({
        url: `/auto-infracoes/listar-reincidencias?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
      }),
      providesTags: ['reincidencias'],
    }),
    getListaReincidenciasRevisadas: build.query({
      query: ({ page, pageSize }) => ({
        url: `/auto-infracoes/listar-reincidencias-revisadas?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
      }),
      providesTags: ['reincidencias'],
    }),
    getListaReincidenciasPermitidas: build.query({
      query: ({ page, pageSize }) => ({
        url: `/auto-infracoes/listar-reincidencias-permitidas?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
      }),
      providesTags: ['reincidencias'],
    }),
    addFaixaInfracao: build.mutation({
      // chame com: { numerosFaixa, clienteId, orgaoId }
      query: ({ numerosFaixa, clienteId = getClienteId(), orgaoId }) => ({
        url: `/faixa-autos/?cliente_id=${encodeURIComponent(clienteId ?? '')}`,
        method: 'POST',
        body: {
          numerosFaixa,
          clienteId: getClienteIdNumber(),
          ...(orgaoId != null ? { orgaoId: Number(orgaoId) } : {}),
        },
      }),
      invalidatesTags: ['totalFaixa', 'listaFaixa'],
    }),
    getTotalFaixa: build.query({
      // chame com: useGetTotalFaixaQuery({ orgaoId, clienteId })
      query: ({ orgaoId, clienteId }) => {
        const qs = new URLSearchParams();
        if (orgaoId != null && orgaoId !== '') qs.set('orgao_id', String(orgaoId));
        if (clienteId != null) qs.set('cliente_id', String(clienteId));
        return { url: `/faixa-autos/totais?${qs.toString()}`, method: 'GET' };
      },
      providesTags: ['totalFaixa'],
    }),
    // Removido duplicata, lógica movida para getOrgaosVinculados abaixo
    getReservaTaloes: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/auto-infracoes/taloes-por-orgaos?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['reservaTaloes']
    }),
    getAgentes: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/agentes/listar?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['GestaoAgentes'],
    }),
    getAgentePorId: build.query({
      query: ({ id }) => ({
        url: `/agentes/${id}`,
      }),
      providesTags: ['GestaoAgentes'],
    }),
    adicionarAgente: build.mutation({
      query: (novoAgente) => ({
        url: '/agentes/adicionar',
        method: 'POST',
        body: { ...novoAgente, cliente_id: getClienteId() },
      }),
      invalidatesTags: ['Agentes'],
    }),
    adicionarUsuario: build.mutation({
      query: (novoUsuario) => ({
        url: '/usuarios/adicionar',
        method: 'POST',
        body: { ...novoUsuario, cliente_id: getClienteId() },
      }),
      invalidatesTags: ['Usuarios'],
    }),
    getUsuario: build.query({
      query: (id) => ({
        url: `/usuarios/listando/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Usuario', id }],
      keepUnusedDataFor: 0,
    }),
    getAssuntosInfracoes: build.query({
      query: () => ({
        url: '/assuntos-infracoes',
        method: 'GET',
      }),
      providesTags: ['AssuntosInfracoes'],
    }),
    updateAssuntoInfracao: build.mutation({
      query: ({ id, assunto, ativo }) => ({
        url: `/assuntos-infracoes/${id}`,
        method: 'PUT',
        body: { assunto, ativo },
      }),
      invalidatesTags: ['AssuntosInfracoes'],
    }),
    getArtigoInfracoes: build.query({
      query: () => ({
        url: '/artigos-infracoes',
        method: 'GET',
      }),
      providesTags: ['ArtigoInfracoes'],
    }),
    updateArtigoInfracao: build.mutation({
      query: ({ id, artigo, ativo }) => ({
        url: `/artigos-infracoes/${id}`,
        method: 'PUT',
        body: { artigo, ativo },
      }),
      invalidatesTags: ['ArtigoInfracoes'],
    }),
    // getLogsAcesso: build.query({
    //   query: ({ page, pageSize, search }) => ({
    //     url: `/logs?orgao_id=${getOrgaoId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
    //     method: 'GET',
    //   }),
    //   providesTags: ['Logs'],
    // }),

    //reuisicao nova detro
    getLogsAcesso: build.query({
      query: ({
        page,
        pageSize,
        search,
        cliente_id,
        clienteId,
        grupo,
        dispositivo,
        status,
        data_inicio,
        data_fim,
      }) => {
        const params = new URLSearchParams({
          page: String(page),
          pageSize: String(pageSize),
          search: search || '',
        });
        const selectedClienteId = cliente_id || clienteId;

        if (selectedClienteId) params.set('cliente_id', selectedClienteId);
        if (grupo) params.set('grupo', grupo);
        if (dispositivo) params.set('dispositivo', dispositivo);
        if (status) params.set('status', status);
        if (data_inicio) params.set('data_inicio', data_inicio);
        if (data_fim) params.set('data_fim', data_fim);

        return {
          url: `/logs?${params.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['Logs'],
    }),
    getLogsApis: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/logs/logs-apis?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['LogsApis'],
    }),
    getLogsBiometricos: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/logs/logs-biometricos?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['LogsBiometricos'],
    }),
    getLogsNotificacoes: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/logs/logs-notificacoes?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['LogsNotificacoes'],
    }),
    getOrgaos: build.query({
      query: () => ({
        url: '/orgaos',
      }),
      providesTags: ['Orgaos'],
    }),
    getUsuarios: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/usuarios/listar?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
      }),
      providesTags: ['GestaoUsuarios'],
      keepUnusedDataFor: 0,
    }),
    getUsuariosPorId: build.query({
      query: ({ id }) => ({
        url: `/usuarios/listando/${id}`,
      }),
      providesTags: ['GestaoUsuarios'],
    }),
    getDispositivos: build.query({
      query: ({ page, pageSize, search, tipo_dispositivo_id, cliente_id, operational_status }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          pageSize: pageSize.toString(),
          ...(search && { search }),
          ...(tipo_dispositivo_id && { tipo_dispositivo_id: tipo_dispositivo_id.toString() }),
          ...(cliente_id && { cliente_id: cliente_id.toString() }),
          ...(operational_status && { operational_status })
        });

        return {
          url: `/dispositivo/listar-dispostivos?${params.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['Dispositivo', 'Dispositivos'],
    }),

    getDispositivo: build.query({
      query: (id) => ({
        url: `/dispositivo/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Dispositivo', id }],
    }),

    editDispositivo: build.mutation({
      query: ({
        id,
        tipo_dispositivo_id,
        etiqueta_patrimonio,
        imei_do_aparelho,
        imei_do_aplicativo,
        iccid_chip_1,
        iccid_chip_2,
        numero_serie,
        operadora,
        numero,
        agente_id,
        cliente_id,
        unidade_id,
        data_saida_estoque,
        retirado_por,
        status,
        status_operacional,
        marca,
        modelo,
        ano,
        nf,
        nome
      }) => {

        let dataFormatada = data_saida_estoque;
        if (data_saida_estoque) {
          if (data_saida_estoque.includes('T')) {
            dataFormatada = data_saida_estoque.split('T')[0];
          }
          else if (data_saida_estoque instanceof Date) {
            dataFormatada = data_saida_estoque.toISOString().split('T')[0];
          }
        }

        return {
          url: `/dispositivo/editar/${id}`,
          method: 'PUT',
          body: {
            tipo_dispositivo_id,
            etiqueta_patrimonio,
            imei_do_aparelho,
            imei_do_aplicativo,
            iccid_chip_1,
            iccid_chip_2,
            numero_serie,
            operadora,
            numero,
            agente_id,
            cliente_id,
            unidade_id,
            data_saida_estoque: dataFormatada, // Usa a data formatada
            retirado_por,
            status,
            status_operacional,
            // NOVOS CAMPOS
            marca,
            modelo,
            ano,
            nf,
            nome
          },
        }
      },
      invalidatesTags: ['Dispositivo', 'Estoque'],
    }),

    bloquearDispositivo: build.mutation({
      query: ({ id, motivo }) => ({
        url: `/dispositivo/bloquear/${id}`,
        method: 'PATCH',
        body: { motivo },
      }),
      invalidatesTags: (_result, _error, { id }) => ['Dispositivo', 'Estoque', { type: 'Dispositivo', id }, { type: 'DispositivoBloqueioLogs', id }],
    }),

    desbloquearDispositivo: build.mutation({
      query: ({ id, motivo }) => ({
        url: `/dispositivo/desbloquear/${id}`,
        method: 'PATCH',
        body: { motivo },
      }),
      invalidatesTags: (_result, _error, { id }) => ['Dispositivo', 'Estoque', { type: 'Dispositivo', id }, { type: 'DispositivoBloqueioLogs', id }],
    }),

    getDispositivoBloqueioLogs: build.query({
      query: (id) => ({
        url: `/dispositivo/bloqueio-logs/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'DispositivoBloqueioLogs', id }],
    }),

    getTiposDispositivo: build.query({
      query: () => ({
        url: '/dispositivo/tipos-dispositivos',
        method: 'GET',
      }),
      providesTags: ['TipoDispositivo'],
    }),


    adicionarDispositivo: build.mutation({
      query: ({
        tipo_dispositivo_id,
        etiqueta_patrimonio,
        imei_do_aparelho,
        imei_do_aplicativo,
        iccid_chip_1,
        iccid_chip_2,
        numero_serie,
        operadora,
        numero,
        agente_id,
        cliente_id,
        unidade_id,
        data_saida_estoque,
        retirado_por,
        status,
        status_operacional,
        marca,
        modelo,
        ano,
        nf,
        nome
      }) => ({
        url: '/dispositivo',
        method: 'POST',
        body: {
          tipo_dispositivo_id,
          etiqueta_patrimonio,
          imei_do_aparelho,
          imei_do_aplicativo,
          iccid_chip_1,
          iccid_chip_2,
          numero_serie,
          operadora,
          numero,
          agente_id,
          cliente_id,
          unidade_id,
          data_saida_estoque,
          retirado_por,
          status: status || 'ativo',
          status_operacional: status_operacional || 'ESTOQUE',
          marca,
          modelo,
          ano,
          nf,
          nome
        },
      }),
      invalidatesTags: ['Dispositivo', 'Estoque'],
    }),
    getEquipamentosAfericao: build.query({
      query: ({ page, pageSize, search, cliente_id }) => ({
        url: `/equipamentos-afericao/listar?cliente_id=${cliente_id || getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['EquipamentosAfericao'],
    }),
    getEquipamentoAfericaoPorId: build.query({
      query: (id) => ({
        url: `/equipamentos-afericao/listar/${id}`,
        method: 'GET',
      }),
      providesTags: ['EquipamentosAfericao'],
    }),
    getLegislacaoInfracoes: build.query({
      query: () => ({ url: '/legislacao-infracoes', method: 'GET' }),
      providesTags: ['LegislacaoInfracoes'],
    }),
    updateLegislacaoInfracao: build.mutation({
      query: ({ id, decreto, descricao, ativo }) => ({
        url: `/legislacao-infracoes/${id}`,
        method: 'PUT',
        body: { decreto, descricao, ativo },
      }),
      invalidatesTags: ['LegislacaoInfracoes'],
    }),
    editEquipamentoAfericao: build.mutation({
      query: ({ id, nome, tipo, marca, modelo, numero_serie, unidade_medida, portaria,
        data_calibracao, validade_calibracao, cliente_id, status, status_operacional }) => ({
          url: `/equipamentos-afericao/editar/${id}`,
          method: 'PUT',
          body: {
            nome,
            tipo,
            marca,
            modelo,
            numero_serie,
            unidade_medida,
            portaria,
            data_calibracao,
            validade_calibracao,
            cliente_id,
            status,
            status_operacional
          },
        }),
      invalidatesTags: ['EquipamentosAfericao'],
    }),
    adicionarEquipamentoAfericao: build.mutation({
      query: ({
        nome,
        tipo,
        marca,
        modelo,
        numero_serie,
        unidade_medida,
        portaria,
        data_calibracao,
        validade_calibracao,
        cliente_id,
        status = 'ativo',
        status_operacional = 'EM_USO'
      }) => ({
        url: '/equipamentos-afericao/adicionar',
        method: 'POST',
        body: {
          nome,
          tipo,
          marca,
          modelo,
          numero_serie,
          unidade_medida,
          portaria,
          data_calibracao,
          validade_calibracao,
          cliente_id,
          status,
          status_operacional
        },
      }),
      invalidatesTags: ['EquipamentosAfericao'],
    }),
    getAgentesByCliente: build.query({
      query: (arg) => {
        const params = typeof arg === 'object'
          ? arg
          : { cliente_id: arg };
        const queryParams = new URLSearchParams({
          ...(params.cliente_id && { cliente_id: params.cliente_id }),
          ...(params.tipo_dispositivo_id && { tipo_dispositivo_id: params.tipo_dispositivo_id }),
          ...(params.dispositivo_id && { dispositivo_id: params.dispositivo_id }),
        });

        return {
          url: `/dispositivo/agentes/cliente?${queryParams.toString()}`,
          method: 'GET',
        };
      },
    }),

    editEquipamento: build.mutation({
      query: ({ id, nome, tipo, modelo, unidade_medida, marca, numero_serie, portarias_regulamentadoras,
        data_calibracao, ativo, validade_calibracao }) => ({
          url: `/equipamentos/editar/${id}`,
          method: 'PUT',
          body: {
            nome, tipo, modelo, unidade_medida, marca, numero_serie, portarias_regulamentadoras,
            data_calibracao, ativo, validade_calibracao
          },
        }),
      invalidatesTags: ['Equipamentos'],
    }),
    adicionarEquipamento: build.mutation({
      query: ({ nome, tipo, modelo, unidade_medida, marca, numero_serie, portarias_regulamentadoras,
        data_calibracao, validade_calibracao, orgao_id }) => ({
          url: '/equipamentos',
          method: 'POST',
          body: {
            nome, tipo, modelo, unidade_medida, marca, numero_serie, portarias_regulamentadoras,
            data_calibracao, validade_calibracao, orgao_id
          },
        }),
      invalidatesTags: ['Equipamentos'],
    }),
    getInfracoes: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/infracoes-transito/infracaoTransito`,
        params: { page, pageSize, search },
      }),
    }),
    getTipoInfracao: build.query({
      query: () => ({
        url: `/tipo-infracoes`,
        method: 'GET',
      }),
      providesTags: ['tipoInfracoes'],
    }),
    getTipoVeiculo: build.query({
      query: () => ({
        url: `/tipo-veiculos`,
        method: 'GET',
      }),
      providesTags: ['tipoVeiculos'],
    }),
    getInfrator: build.query({
      query: () => ({
        url: `/infrator`,
        method: 'GET',
      }),
      providesTags: ['infrator'],
    }),
    getConfiguraCrimeTransito: build.query({
      query: () => ({
        url: `/configura-crime-transito`,
        method: 'GET',
      }),
      providesTags: ['configuraCrimeTransito'],
    }),
    getGravidade: build.query({
      query: () => ({ url: '/gravidades', method: 'GET' }),
      providesTags: ['gravidade'],
    }),
    getGrupoInfracao: build.query({
      query: () => ({ url: '/grupos-infracoes', method: 'GET' }),
      providesTags: ['grupo_infracao'],
    }),
    getMedidaAdministrativaInfracao: build.query({
      query: () => ({ url: '/medidas-administrativas', method: 'GET' }),
      providesTags: ['medida_administrativa'],
    }),
    getPenalidade: build.query({
      query: () => ({
        url: `/penalidades`,
        method: 'GET',
      }),
      providesTags: ['penalidade'],
    }),
    getSimCartao: build.query({
      query: () => ({
        url: `/sim-cartao`,
        method: 'GET',
      }),
      providesTags: ['simCartao'],
    }),
    getSimCartaoPorId: build.query({
      query: (id) => ({
        url: `/sim-cartao/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'simCartao', id }],
    }),
    editSimCartao: build.mutation({
      query: ({ id, operadora, numero, iccid, puk1, puk2, eSIM, status, cliente_id, dispositivo_id }) => ({
        url: `/sim-cartao/${id}`,
        method: 'PUT',
        body: { id, operadora, numero, iccid, puk1, puk2, eSIM, status, cliente_id, dispositivo_id },
      }),
      invalidatesTags: ['simCartao'],
    }),
    getTodosSimCartao: build.query({
      query: ({ page = 0, pageSize = 100, search = '', cliente_id } = {}) => {
        const params = new URLSearchParams({
          page: page.toString(),
          pageSize: pageSize.toString(),
          ...(search && { search }),
          ...(cliente_id && { cliente_id: cliente_id.toString() })
        });

        return {
          url: `/sim-cartao/listar-todos?${params.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['simCartao'],
    }),
    editRemoverCartao: build.mutation({
      query: ({ id }) => ({
        url: `/sim-cartao/remover-cartao/${id}`,
        method: 'PUT',
        body: { id },
      }),
      invalidatesTags: ['simCartao'],
    }),
    addNovoChip: build.mutation({
      query: ({ operadora, numero, iccid, puk1, puk2, eSIM, status, cliente_id, dispositivo_id }) => ({
        url: '/sim-cartao',
        method: 'POST',
        body: { operadora, numero, iccid, puk1, puk2, eSIM, status, cliente_id, dispositivo_id },
      }),
      invalidatesTags: ['simCartao'],
    }),
    AddAgenteOrgaos: build.mutation({
      query: ({ agente_id, orgao_ids }) => ({
        url: '/orgaos/agentes/add-agente-orgao',
        method: 'POST',
        body: { agente_id, orgao_ids },
      }),
      invalidatesTags: ['Agentes'],
    }),
    addOrgaoConveniados: build.mutation({
      query: ({ orgao_id, conveniado_ids }) => ({
        url: '/orgaos/add-orgao-conveniado',
        method: 'POST',
        body: { orgao_id, conveniado_ids },
      }),
      invalidatesTags: ['Orgaos'],
    }),
    removeAgenteOrgaos: build.mutation({
      query: ({ agente_id, orgao_ids }) => ({
        url: '/orgaos/agentes/remove-agente-orgao',
        method: 'DELETE',
        body: { agente_id, orgao_ids },
      }),
      invalidatesTags: ['Agentes'],
    }),
    removeOrgaoConveniados: build.mutation({
      query: ({ orgao_id, conveniado_ids }) => ({
        url: '/orgaos/remove-orgao-conveniado',  // Rota de remoção
        method: 'DELETE',  // Usando DELETE para remover
        body: { orgao_id, conveniado_ids },  // Dados que serão enviados no corpo da requisição
      }),
      invalidatesTags: ['Orgaos'],  // Invalida os dados de 'Agentes' para re-fetch
    }),
    getImpressoras: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/impressoras?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['Impressoras'],
    }),
    editImpressora: build.mutation({
      query: ({ id, nome, tipo, modelo, fabricante, numero_serie, portarias_regulamentadoras,
        data_calibracao, validade_calibracao }) => ({
          url: `/impressoras/editar/${id}`,
          method: 'PUT',
          body: {
            nome, tipo, modelo, fabricante, numero_serie, portarias_regulamentadoras,
            data_calibracao, validade_calibracao
          },
        }),
      invalidatesTags: ['Impressoras'],
    }),
    adicionarImpressora: build.mutation({
      query: ({ nome, tipo, modelo, fabricante, numero_serie, portarias_regulamentadoras,
        data_calibracao, validade_calibracao, orgao_id }) => ({
          url: '/impressoras',
          method: 'POST',
          body: {
            nome, tipo, modelo, fabricante, numero_serie, portarias_regulamentadoras,
            data_calibracao, validade_calibracao, orgao_id
          },
        }),
      invalidatesTags: ['Impressoras'],
    }),
    getAutosErro: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/auto-infracao-erro?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['AutosErro'],
    }),
    getAITsDia: build.query({
      query: () => ({
        url: `/dashboard/aits-dia?cliente_id=${getClienteId()}`,
        method: 'GET',
      }),
      providesTags: ['AutosDoDia'],
    }),
    getAITsDiaAnterior: build.query({
      query: () => ({
        url: `/dashboard/aits-dia-anterior?cliente_id=${getClienteId()}`,
        method: 'GET',
      }),
      providesTags: ['AutosDiaAnterior'],
    }),
    getAITsSemana: build.query({
      query: () => ({
        url: `/dashboard/aits-semana?cliente_id=${getClienteId()}`,
        method: 'GET',
      }),
      providesTags: ['AutosSemana'],
    }),
    getAITsMes: build.query({
      query: () => ({
        url: `/dashboard/aits-mes?cliente_id=${getClienteId()}`,
        method: 'GET',
      }),
      providesTags: ['AutosMes'],
    }),
    getTotalAgentes: build.query({
      query: () => ({
        url: `/dashboard/total-agentes?cliente_id=${getClienteId()}`,
        method: 'GET',
      }),
      providesTags: ['TotalAgentes'],
    }),
    getIncidenciaInfracoes: build.query({
      query: ({ periodo_inicio, periodo_fim }) => ({
        url: `/relatorios/incidencia-infracoes-criado`,
        method: 'GET',
        params: {
          cliente_id: getClienteId(),
          periodo_inicio,
          periodo_fim,
        },
      }),
      providesTags: ['relatorios'],
    }),
    getTotalAutosAgente: build.query({
      query: ({ periodo_inicio, periodo_fim }) => ({
        url: `/relatorios/total-infracoes-agentes-criado`,
        method: 'GET',
        params: {
          cliente_id: getClienteId(),
          periodo_inicio,
          periodo_fim,
        },
      }),
      providesTags: ['relatorios'],
    }),
    getGrvs: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/grv?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['Grv'],
    }),
    getDetalhesGrv: build.query({
      query: (id) => ({
        url: `/grv/${id}`,
      }),
      providesTags: (result, error, id) => [{ type: 'DetalhesGrv', id }],
    }),
    getDetalhesGrd: build.query({
      query: (id) => ({
        url: `/termos-recolhimento-documento/${id}`,
      }),
      providesTags: (result, error, id) => [{ type: 'DetalhesGrd', id }],
    }),
    getDetalhesMedidaAdministrativaAvulsa: build.query({
      query: (id) => ({
        url: `/termos-medida-administrativa/${id}`,
      }),
      providesTags: (result, error, id) => [{ type: 'DetalhesMedidaAdministrativaAvulsa', id }],
    }),
    getSinaisNotorios: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/termos-sinais-notorios/listar?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['SinaisNotorio'],
    }),
    getDetalhesSinaisNotorios: build.query({
      query: (id) => ({
        url: `/termos-sinais-notorios/${id}`,
      }),
      providesTags: (result, error, id) => [{ type: 'DetalhesSinaisNotorios', id }],
    }),
    getDetalhesBoletimSinistro: build.query({
      query: (id) => ({
        url: `/sinistros/${id}`,
      }),
      providesTags: (result, error, id) => [{ type: 'DetalhesBoletimSinistro', id }],
    }),
    getVeiculo: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/veiculos?page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['veiculo'],
    }),
    getHabilitacao: build.query({
      query: () => ({
        url: `/habilitacoes`,
        method: 'GET',
      }),
      providesTags: ['Habilitacao'],
    }),
    editVeiculo: build.mutation({
      query: ({ id, placa, marca, modelo, name, especie, cor, chassi, situacao, estado, cidade, tipo_veiculo, codigo_retorno,
        renavam, ano_fabricacao, ano_modelo, capacidade_carga, capacidade_passageiros, potencia, cilindrada, categoria, combustivel
      }) => ({
        url: `/veiculos/editar/${id}`,
        method: 'PUT',
        body: {
          id, placa, marca, modelo, name, especie, cor, chassi, situacao, estado, cidade, tipo_veiculo, codigo_retorno,
          renavam, ano_fabricacao, ano_modelo, capacidade_carga, capacidade_passageiros, potencia, cilindrada, categoria, combustivel
        },
      }),
      invalidatesTags: ['Veiculos'],
    }),
    editHabilitacao: build.mutation({
      query: ({ id, numregistro, numpgu, cpf, categoria, validade, nome, logradouro,
        num_end, compl_end, mun, municipio, estado, bairro, cep, ocorrencias
      }) => ({
        url: `/habilitacoes/editar/${id}`,
        method: 'PUT',
        body: {
          id, numregistro, numpgu, cpf, categoria, validade, nome, logradouro,
          num_end, compl_end, mun, municipio, estado, bairro, cep, ocorrencias
        },
      }),
      invalidatesTags: ['Habilitacao'],
    }),
    getClientes: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/clientes/listar?page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      transformResponse: (response) => ({
        clientes: response.retorno || [],
        totalItems: response.total || 0,
      }),
      providesTags: ['Clientes'],
    }),
    getClientePorId: build.query({
      query: (id) => ({
        url: `/clientes/${id}`,
      }),
      transformResponse: (response) => ({
        cliente: response?.cliente ?? response?.retorno?.[0] ?? null,
        retorno: response?.retorno ?? (response?.cliente ? [response.cliente] : []),
      }),
      providesTags: (result, error, id) => [{ type: 'Clientes', id }],
    }),
    addCliente: build.mutation({
      query: (fields) => ({
        url: '/clientes',
        method: 'POST',
        body: sanitizeClientePayload(fields),
      }),
      invalidatesTags: ['Clientes'],
    }),
    updateCliente: build.mutation({
      query: ({ id, ...fields }) => ({
        url: `/clientes/editar/${id}`,
        method: 'POST',
        body: sanitizeClientePayload(fields),
      }),
      invalidatesTags: ['Clientes'],
    }),
    subirLogoGestaoCliente: build.mutation({
      query: ({ id, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/clientes/subir-logo-gestao/${id}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Clientes'],
    }),
    subirLogoAppCliente: build.mutation({
      query: ({ id, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/clientes/subir-logo-app/${id}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Clientes'],
    }),
    subirLogoIconeCliente: build.mutation({
      query: ({ id, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/clientes/subir-logo-icone/${id}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Clientes'],
    }),
    vincularOrgao: build.mutation({
      query: (body) => ({
        url: '/clientes/vincular-orgao',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Clientes'],
    }),
    desvincularOrgao: build.mutation({
      query: (body) => ({
        url: '/clientes/desvincular-orgao',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Clientes'],
    }),
    getOrgaosVinculados: build.query({
      query: (arg) => {
        // Pode vir como ID direto ou objeto { cliente_id: ... }
        const id = (arg && typeof arg === 'object') ? arg.cliente_id : arg;
        
        // Se não houver ID, tenta listar todos os órgãos
        if (!id) {
          return { url: '/orgaos/listar-orgaos?page=1&pageSize=1000', method: 'GET' };
        }
        
        return { url: `/clientes/listar-orgaos-vinculados/${id}`, method: 'GET' };
      },
      transformResponse: (response) => {
        // Se vier do novo endpoint de vínculo, extrai o objeto 'orgao'
        if (response.retorno && Array.isArray(response.retorno) && response.retorno.length > 0 && response.retorno[0].orgao) {
          return response.retorno.map(v => v.orgao);
        }
        // Caso contrário, retorna o array de órgãos direto (ou da listagem geral)
        return response.retorno || response.resposta || response.resultado || [];
      },
      providesTags: (result, error, arg) => {
        const id = (arg && typeof arg === 'object') ? arg.cliente_id : arg;
        return [{ type: 'Clientes', id: id || 'all', sub: 'vinculados' }];
      },
    }),
    getOrgaosVinculadosCliente: build.query({
      query: (id) => ({
        url: `/clientes/${id}/orgaos`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Clientes', id, sub: 'orgaos-vinculados' }],
    }),
    getOrgaosDisponiveis: build.query({
      query: ({ cliente_id, search = '' }) => ({
        url: `/orgaos/disponiveis?cliente_id=${cliente_id}&search=${encodeURIComponent(search)}`,
        method: 'GET',
      }),
      providesTags: (result, error, { cliente_id }) => [{ type: 'Clientes', id: cliente_id, sub: 'orgaos-disponiveis' }],
    }),
    vincularOrgaoCliente: build.mutation({
      query: ({ cliente_id, orgao_id }) => ({
        url: `/clientes/${cliente_id}/vincular-orgao`,
        method: 'POST',
        body: { orgao_id },
      }),
      invalidatesTags: (result, error, { cliente_id }) => [
        { type: 'Clientes', id: cliente_id, sub: 'orgaos-vinculados' },
        { type: 'Clientes', id: cliente_id, sub: 'orgaos-disponiveis' }
      ],
    }),
    desvincularOrgaoCliente: build.mutation({
      query: ({ cliente_id, orgao_id }) => ({
        url: `/clientes/${cliente_id}/desvincular-orgao/${orgao_id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { cliente_id }) => [
        { type: 'Clientes', id: cliente_id, sub: 'orgaos-vinculados' },
        { type: 'Clientes', id: cliente_id, sub: 'orgaos-disponiveis' }
      ],
    }),
    addEscala: build.mutation({
      query: (body) => ({
        url: "/escalas/adicionar",
        method: "POST",
        body: { ...body, cliente_id: getClienteId() },
      }),
      invalidatesTags: ["Escalas"],
    }),
    editEscala: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/escalas/atualizar/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Escalas"],
    }),
    deleteEscala: build.mutation({
      query: ({ id }) => ({
        url: `/escalas/deletar/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Escalas"],
    }),
    getEscalas: build.query({
      query: () => `/escalas/listar?cliente_id=${getClienteId()}`,
      providesTags: ["Escalas"],
    }),
    getLogsEscala: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/logs-escala/listar?page=${page}&pageSize=${pageSize}&search=${search}&cliente_id=${getClienteId()}`,
        method: 'GET',
      }),
      providesTags: ['LogsEscala'],
    }),

    listarEstados: build.query({
      query: () => '/orgaos/listar-estados',
      providesTags: ['Estados'],
    }),

    listarMunicipio: build.query({
      query: ({ estadoId }) => ({
        url: estadoId
          ? `/orgaos/listar-municipio?estado_id=${estadoId}`
          : '/listar-municipio',
      }),
      providesTags: ['Municipios'],
    }),
    getOrgaosList: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/orgaos/listar-orgaos?page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET'
      }),
      transformResponse: (response) => ({
        resposta: response.retorno || [],
        totalItems: response.total || 0,
      }),
      providesTags: ['Orgaos'],
    }),
    // Avisos API
    getAvisos: build.query({
      query: ({ page = 0, pageSize = 25, search }) => ({
        url: `/avisos/listar?page=${page}&pageSize=${pageSize}&search=${search}`,
        method: 'GET',
      }),
      providesTags: ['Avisos'],
    }),

    getAvisoPorId: build.query({
      query: (id) => ({
        url: `/avisos/listar/${id}`,
        method: 'GET',
      }),
      providesTags: ['Avisos'],
    }),

    criarAviso: build.mutation({
      query: (body) => ({
        url: `/avisos/criar`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Avisos'],
    }),

    editarAviso: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/avisos/editar/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Avisos'],
    }),

    deletarAviso: build.mutation({
      query: (id) => ({
        url: `/avisos/deletar/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Avisos'],
    }),

    subirImagemAviso: build.mutation({
      query: ({ id, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/avisos/upload-imagem/${id}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Avisos'],
    }),

    getAvisosPorCliente: build.query({
      query: ({ cliente_id }) => ({
        url: `/avisos/cliente/${cliente_id}`,
        method: 'GET',
      }),
      providesTags: ['Avisos'],
    }),
    // Importancias Avisos API
    getImportanciasAvisos: build.query({
      query: () => ({
        url: `/importancias/listar`,
        method: 'GET',
      }),
      providesTags: ['Importancias'],
    }),
    vincularClientesAviso: build.mutation({
      query: (body) => ({
        url: `/aviso-clientes/criar`,
        method: 'POST',
        body: {
          aviso_ids: body.avisosSelecionados,
          cliente_ids: body.clientesSelecionados
        }
      }),
      invalidatesTags: ['Avisos', 'ClientesVinculados'],
    }),
    atribuirFaixaDispositivo: build.mutation({
      query: ({ orgaoId, dispositivoId, qtdFaixa }) => ({
        url: `/faixa-autos/atribuir-dispositivo?orgao_id=${encodeURIComponent(orgaoId ?? '')}`,
        method: 'PUT',
        body: {
          dispositivoId,
          qtdFaixa,
          clienteId: getClienteIdNumber(), // multi-tenant
        },
      }),
      invalidatesTags: ['totalFaixa', 'Dispositivos'],
    }),
    getFaixasPorDispositivo: build.query({
      query: ({ page, pageSize, orgaoId, search }) => {
        const params = new URLSearchParams({
          cliente_id: String(getClienteId()),
          page: String(page ?? 0),
          pageSize: String(pageSize ?? 25),
        });
        if (Number.isFinite(orgaoId)) params.append('orgao_id', String(orgaoId));
        if (search != null && search !== '') params.append('search', String(search));

        return { url: `/faixa-autos/dispositivos/estoque?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['Dispositivos', 'totalFaixa'],
    }),
    getTotaisDisponiveisPorOrgao: build.query({
      query: (clienteId) => {
        const params = new URLSearchParams({ cliente_id: String(clienteId) });
        return { url: `/faixa-autos/totais-disponiveis?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['totalFaixa'],
    }),
    getResumoPorDispositivo: build.query({
      query: ({ dispositivo_id, cliente_id = getClienteIdNumber() }) => ({
        url: '/faixa-autos/resumo-por-dispositivo',
        method: 'GET',
        params: { dispositivo_id, ...(cliente_id != null && { cliente_id }) },
      }),
      transformResponse: (resp) => resp?.retorno ?? resp ?? [],
      providesTags: (_res, _err, args) => [{ type: 'ResumoDispositivo', id: args.dispositivo_id }],
    }),
    removeFaixaDoDispositivo: build.mutation({
      query: ({ dispositivo_id, orgao_id, qtdRemover, cliente_id }) => ({
        url: '/faixa-autos/remove',
        method: 'DELETE',
        params: {
          dispositivo_id: Number(dispositivo_id),
          cliente_id: Number(cliente_id),
          ...(orgao_id != null && { orgao_id: Number(orgao_id) }),
          ...(qtdRemover != null && { qtdRemover: Number(qtdRemover) }),
        },
      }),
      invalidatesTags: (_res, _err, args) => [
        'totalFaixa',
        'Dispositivos',
        { type: 'ResumoDispositivo', id: args?.dispositivo_id },
      ],
    }),
    getResumoEstoque: build.query({
      query: ({ cliente_id = getClienteIdNumber() } = {}) => ({
        url: '/estoque/resumo',
        method: 'GET',
        params: { ...(cliente_id !== undefined && cliente_id !== null && cliente_id !== '' && { cliente_id }) },
      }),
      providesTags: ['Estoque'],
    }),
    getEstoqueMovimentacoes: build.query({
      query: ({ page = 0, pageSize = 100, search = '', cliente_id = getClienteIdNumber() } = {}) => ({
        url: '/estoque',
        method: 'GET',
        params: {
          page,
          pageSize,
          ...(search && { search }),
          ...(cliente_id !== undefined && cliente_id !== null && cliente_id !== '' && { cliente_id }),
        },
      }),
      providesTags: ['Estoque'],
    }),
    getEstoqueMovimentacao: build.query({
      query: (id) => ({
        url: `/estoque/${id}`,
        method: 'GET',
      }),
      providesTags: (_res, _err, id) => [{ type: 'Estoque', id }],
    }),
    adicionarEstoqueMovimentacao: build.mutation({
      query: (body) => ({
        url: '/estoque',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Estoque'],
    }),
    editarEstoqueMovimentacao: build.mutation({
      query: ({ id, body, ...rest }) => ({
        url: `/estoque/${id}`,
        method: 'PUT',
        body: body || rest,
      }),
      invalidatesTags: (_res, _err, args) => ['Estoque', { type: 'Estoque', id: args?.id }],
    }),
    importarEstoqueLote: build.mutation({
      query: (body) => ({
        url: '/estoque/importar-lote',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Estoque', 'Dispositivo', 'Dispositivos', 'Impressoras', 'simCartao'],
    }),
    getLogsTransporte: build.query({
      query: ({ page = 0, pageSize = 25, search = '', clienteId: clienteIdArg }) => {
        const cid = (clienteIdArg ?? getClienteId?.()) ?? null;

        return {
          url: '/logs/logs-auto-transporte',
          params: { page, pageSize, search, clienteId: cid },
          method: 'GET',
        };
      },
      providesTags: ['LogsAutoTransporte'],
    }),
    // // Avisos vinculados a clientes
    // getAvisosVinculadosPorCliente: build.query({
    //   query: ({ cliente_id }) => ({
    //     url: `/aviso-clientes/listar`,
    //     method: 'GET',
    //   }),
    //   providesTags: ['ClientesVinculados'],
    // }),
    // Avisos vinculados a clientes
    getAvisosVinculadosPorCliente: build.query({
      query: () => ({
        url: `/aviso-clientes/listar`,
        method: 'GET',
      }),
      providesTags: ['ClientesVinculados'],
    }),
    desvincularAvisosPorCliente: build.mutation({
      query: ({ aviso_id, cliente_id }) => ({
        url: `/aviso-clientes/deletar`,
        method: 'DELETE',
        body: { aviso_id, cliente_id },
      }),
      providesTags: ['ClientesVinculados'],
    }),
    getFeedbacksPorCliente: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/feedbacks/listar?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}&search=${search}`,
      }),
      providesTags: ['feedback'],
    }),

    // ============ NOTIFICAÇÕES ============
    getNotificacoes: build.query({
      query: ({ page = 0, pageSize = 25 }) => ({
        url: `/notificacoes/listar?cliente_id=${getClienteId()}&page=${page}&pageSize=${pageSize}`,
        method: 'GET',
      }),
      providesTags: ['Notificacoes'],
    }),
    getNotificacaoPorId: build.query({
      query: (id) => ({
        url: `/notificacoes/listar/${id}`,
        method: 'GET',
      }),
      providesTags: ['Notificacoes'],
    }),
    criarNotificacao: build.mutation({
      query: ({ assunto, mensagem, icone }) => ({
        url: '/notificacoes/criar',
        method: 'POST',
        body: {
          assunto,
          mensagem,
          icone,
          cliente_id: getClienteIdNumber(),
          usuario_id: parseInt(localStorage.getItem('id_usuario'), 10)
        },
      }),
      invalidatesTags: ['Notificacoes'],
    }),
    editarNotificacao: build.mutation({
      query: ({ id, assunto, mensagem, status, icone }) => ({
        url: `/notificacoes/editar/${id}`,
        method: 'PUT',
        body: { assunto, mensagem, status, icone },
      }),
      invalidatesTags: ['Notificacoes'],
    }),
    deletarNotificacao: build.mutation({
      query: (id) => ({
        url: `/notificacoes/deletar/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notificacoes'],
    }),
    subirImagemNotificacao: build.mutation({
      query: ({ id, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/notificacoes/upload-imagem/${id}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Notificacoes'],
    }),
    vincularAgentesNotificacao: build.mutation({
      query: ({ notificacao_id, agentes_ids }) => ({
        url: `/notificacoes/vincular/${notificacao_id}`,
        method: 'POST',
        body: { agentes_ids },
      }),
      invalidatesTags: ['Notificacoes'],
    }),
    getLogsNotificacao: build.query({
      query: (notificacao_id) => ({
        url: `/notificacoes/logs/${notificacao_id}`,
        method: 'GET',
      }),
      providesTags: ['Notificacoes'],
    }),
    desvincularAgente: build.mutation({
      query: ({ notificacao_id, agente_id }) => ({
        url: `/notificacoes/desvincular/${notificacao_id}/${agente_id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notificacoes'],
    }),

    // ============ FAQ - DÚVIDAS FREQUENTES ============
    getDuvidasFrequentes: build.query({
      query: ({ page = 0, pageSize = 25 }) => ({
        url: `/duvidas-frequentes/listar?page=${page}&pageSize=${pageSize}`,
        method: 'GET',
      }),
      providesTags: ['DuvidasFrequentes'],
    }),
    getDuvidaFrequentePorId: build.query({
      query: (id) => ({
        url: `/duvidas-frequentes/listar/${id}`,
        method: 'GET',
      }),
      providesTags: ['DuvidasFrequentes'],
    }),
    criarDuvidaFrequente: build.mutation({
      query: ({ icone, titulo, status }) => ({
        url: '/duvidas-frequentes/criar',
        method: 'POST',
        body: { icone, titulo, status },
      }),
      invalidatesTags: ['DuvidasFrequentes'],
    }),
    editarDuvidaFrequente: build.mutation({
      query: ({ id, icone, titulo, status }) => ({
        url: `/duvidas-frequentes/editar/${id}`,
        method: 'PUT',
        body: { icone, titulo, status },
      }),
      invalidatesTags: ['DuvidasFrequentes'],
    }),
    deletarDuvidaFrequente: build.mutation({
      query: (id) => ({
        url: `/duvidas-frequentes/deletar/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DuvidasFrequentes'],
    }),
    getVinculosDuvida: build.query({
      query: (duvida_id) => ({
        url: `/duvidas-frequentes/vinculos/${duvida_id}`,
        method: 'GET',
      }),
      providesTags: ['DuvidasFrequentes'],
    }),
    getArtigosDisponiveis: build.query({
      query: (duvida_id) => ({
        url: `/duvidas-frequentes/disponiveis/${duvida_id}`,
        method: 'GET',
      }),
      providesTags: ['DuvidasFrequentes', 'Artigos'],
    }),
    vincularArtigoDuvida: build.mutation({
      query: ({ duvida_id, artigo_id }) => ({
        url: `/duvidas-frequentes/vincular/${duvida_id}`,
        method: 'POST',
        body: { artigo_id },
      }),
      invalidatesTags: ['DuvidasFrequentes'],
    }),
    desvincularArtigoDuvida: build.mutation({
      query: ({ duvida_id, artigo_id }) => ({
        url: `/duvidas-frequentes/desvincular/${duvida_id}/${artigo_id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DuvidasFrequentes'],
    }),

    // ============ FAQ - ARTIGOS ============
    getArtigos: build.query({
      query: ({ page = 0, pageSize = 25 }) => ({
        url: `/artigos/listar?page=${page}&pageSize=${pageSize}`,
        method: 'GET',
      }),
      providesTags: ['Artigos'],
    }),
    getArtigoPorId: build.query({
      query: (id) => ({
        url: `/artigos/listar/${id}`,
        method: 'GET',
      }),
      providesTags: ['Artigos'],
    }),
    criarArtigo: build.mutation({
      query: ({ titulo, descricao, imagem, url_video, client_id }) => {
        const formData = new FormData();
        formData.append('titulo', titulo);
        formData.append('descricao', descricao);
        if (client_id) formData.append('client_id', client_id);
        if (url_video) formData.append('url_video', url_video);
        if (imagem instanceof File) formData.append('file', imagem);
        else if (imagem) formData.append('imagem', imagem);

        return {
          url: '/artigos/criar',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Artigos'],
    }),
    editarArtigo: build.mutation({
      query: ({ id, titulo, descricao, status, imagem, url_video }) => {
        if (imagem instanceof File) {
          const formData = new FormData();
          if (typeof titulo !== 'undefined') formData.append('titulo', titulo);
          if (typeof descricao !== 'undefined') formData.append('descricao', descricao);
          if (typeof status !== 'undefined') formData.append('status', status);
          if (typeof url_video !== 'undefined') formData.append('url_video', url_video || '');
          formData.append('file', imagem);
          return {
            url: `/artigos/editar/${id}`,
            method: 'PUT',
            body: formData,
          };
        }
        return {
          url: `/artigos/editar/${id}`,
          method: 'PUT',
          body: { titulo, descricao, status, url_video },
        };
      },
      invalidatesTags: ['Artigos'],
    }),
    deletarArtigo: build.mutation({
      query: (id) => ({
        url: `/artigos/deletar/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Artigos'],
    }),
    getDispositivosMes: build.query({
      query: ({ orgaoId, mesInicio, mesFim }) => ({
        url: '/relatorios/dispositivos-mes',
        method: 'GET',
        params: {
          ...(orgaoId && { orgao_id: orgaoId }),
          mes_inicio: mesInicio,
          mes_fim: mesFim
        }
      }),
      providesTags: ['DispositivosPeriodo']
    }),
    getDispositivosNaoUtilizadosMes: build.query({
      query: ({ orgaoId, mesInicio, mesFim }) => ({
        url: '/relatorios/dispositivos-nao-utilizados-mes',
        method: 'GET',
        params: {
          ...(orgaoId && { orgao_id: orgaoId }),
          mes_inicio: mesInicio,
          mes_fim: mesFim
        }
      }),
      providesTags: ['DispositivosNaoUtilizados']
    }),
    getPainelDispositivos: build.query({
      query: ({ inicio, fim, orgaoId }) => ({
        url: "/relatorios/dispositivos-painel",
        params: {
          inicio,
          fim,
          orgao_id: orgaoId, 
        },
      }),
      providesTags: ['PainelDispositivos'],
    }),
    getChats: build.query({
      query: ({ orgao_id, page, limit }) => ({
        url: 'chat',
        method: 'GET',
        params: {
          orgao_id,
          page,
          limit,
        },
      }),
      providesTags: ['Chat'],
    }),

    // ─── Veículos Embarcados ──────────────────────────────────────────────────
    getVeiculosEmbarcados: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/veiculos-embarcados/listar?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search || '')}`,
        method: 'GET',
      }),
      providesTags: ['VeiculosEmbarcados'],
    }),
    getVeiculoEmbarcadoPorId: build.query({
      query: (id) => ({
        url: `/veiculos-embarcados/listar/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'VeiculosEmbarcados', id }],
    }),
    criarVeiculoEmbarcado: build.mutation({
      query: (body) => ({
        url: '/veiculos-embarcados/criar',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['VeiculosEmbarcados'],
    }),
    editarVeiculoEmbarcado: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/veiculos-embarcados/editar/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['VeiculosEmbarcados'],
    }),
    deletarVeiculoEmbarcado: build.mutation({
      query: (id) => ({
        url: `/veiculos-embarcados/deletar/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['VeiculosEmbarcados'],
    }),
    importarCsvVeiculos: build.mutation({
      query: (formData) => ({
        url: '/veiculos-embarcados/importar-csv',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['VeiculosEmbarcados'],
    }),

    // ─── Condutores Embarcados ────────────────────────────────────────────────
    getCondutoresEmbarcados: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/condutores-embarcados/listar?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search || '')}`,
        method: 'GET',
      }),
      providesTags: ['CondutoresEmbarcados'],
    }),
    getCondutorEmbarcadoPorId: build.query({
      query: (id) => ({
        url: `/condutores-embarcados/listar/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'CondutoresEmbarcados', id }],
    }),
    criarCondutorEmbarcado: build.mutation({
      query: (body) => ({
        url: '/condutores-embarcados/criar',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CondutoresEmbarcados'],
    }),
    editarCondutorEmbarcado: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/condutores-embarcados/editar/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['CondutoresEmbarcados'],
    }),
    deletarCondutorEmbarcado: build.mutation({
      query: (id) => ({
        url: `/condutores-embarcados/deletar/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CondutoresEmbarcados'],
    }),
    importarCsvCondutores: build.mutation({
      query: (formData) => ({
        url: '/condutores-embarcados/importar-csv',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['CondutoresEmbarcados'],
    }),

    // ─── Infrações Embarcadas ─────────────────────────────────────────────────
    getInfracoesEmbarcadas: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/infracoes-embarcadas/listar?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search || '')}`,
        method: 'GET',
      }),
      providesTags: ['InfracoesEmbarcadas'],
    }),
    getInfracaoEmbarcadaPorId: build.query({
      query: (id) => ({
        url: `/infracoes-embarcadas/listar/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'InfracoesEmbarcadas', id }],
    }),
    criarInfracaoEmbarcada: build.mutation({
      query: (body) => ({
        url: '/infracoes-embarcadas/criar',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['InfracoesEmbarcadas'],
    }),
    editarInfracaoEmbarcada: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/infracoes-embarcadas/editar/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['InfracoesEmbarcadas'],
    }),
    deletarInfracaoEmbarcada: build.mutation({
      query: (id) => ({
        url: `/infracoes-embarcadas/deletar/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['InfracoesEmbarcadas'],
    }),
    importarCsvInfracoes: build.mutation({
      query: (formData) => ({
        url: '/infracoes-embarcadas/importar-csv',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['InfracoesEmbarcadas'],
    }),
    // ─── Notificações do Painel (suporte humano) ────────────────────────────────
    getNotificacoesPainel: build.query({
      query: ({ cliente_id, lido, page = 0, pageSize = 25 } = {}) => {
        const params = new URLSearchParams({ page, pageSize });
        if (cliente_id) params.set('cliente_id', cliente_id);
        if (typeof lido !== 'undefined') params.set('lido', lido);
        return { url: `/notificacoes-painel/listar?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['NotificacoesPainel'],
    }),
    contarNotificacoesPainelNaoLidas: build.query({
      query: (cliente_id) => ({
        url: `/notificacoes-painel/nao-lidas/${cliente_id}`,
        method: 'GET',
      }),
      providesTags: ['NotificacoesPainel'],
    }),
    marcarNotificacaoPainelComoLida: build.mutation({
      query: (id) => ({
        url: `/notificacoes-painel/lido/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: ['NotificacoesPainel'],
    }),

    // Unidades
    getUnidades: build.query({
      query: ({ page, pageSize, search }) => ({
        url: `/unidades/listar?page=${page}&pageSize=${pageSize}&search=${search ?? ''}`,
        method: 'GET',
      }),
      providesTags: ['Unidades'],
    }),
    getUnidadePorId: build.query({
      query: (id) => ({
        url: `/unidades/${id}`,
        method: 'GET',
      }),
      providesTags: ['Unidades'],
    }),
    addUnidade: build.mutation({
      query: (body) => ({
        url: '/unidades',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Unidades'],
    }),
    updateUnidade: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/unidades/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Unidades'],
    }),

    // Operações
    getOperacoes: build.query({
      query: ({ page = 0, pageSize = 25, search = '', cliente_id, todos = 'true' } = {}) => {
        const params = new URLSearchParams({
          page: String(page),
          pageSize: String(pageSize),
          todos,
        });
        if (search) params.set('search', search);
        if (cliente_id) params.set('cliente_id', String(cliente_id));
        return { url: `/operacoes?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['Operacoes'],
    }),

    // Tipos de Operação
    getTiposOperacao: build.query({
      query: ({ page, pageSize, search = '', cliente_id, incluir_inativos = 'true' } = {}) => {
        const params = new URLSearchParams();
        if (page !== undefined) params.set('page', String(page));
        if (pageSize !== undefined) params.set('pageSize', String(pageSize));
        if (search) params.set('search', search);
        if (cliente_id) params.set('cliente_id', String(cliente_id));
        params.set('incluir_inativos', incluir_inativos);
        return { url: `/operacoes/tipos?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['TiposOperacao'],
    }),
    getTipoOperacaoPorId: build.query({
      query: (id) => ({ url: `/operacoes/tipos/${id}`, method: 'GET' }),
      providesTags: ['TiposOperacao'],
    }),
    criarTipoOperacao: build.mutation({
      query: (body) => ({ url: '/operacoes/tipos', method: 'POST', body }),
      invalidatesTags: ['TiposOperacao'],
    }),
    atualizarTipoOperacao: build.mutation({
      query: ({ id, ...body }) => ({ url: `/operacoes/tipos/${id}`, method: 'PUT', body }),
      invalidatesTags: ['TiposOperacao'],
    }),
    excluirTipoOperacao: build.mutation({
      query: (id) => ({ url: `/operacoes/tipos/${id}`, method: 'DELETE' }),
      invalidatesTags: ['TiposOperacao'],
    }),
  }),
});


export const {
  useGetAutosInfracaoQuery:
  useAutosInfracaoQuery,
  useAddConveniadosMutation,
  useAddOrgaoConveniadosMutation,
  useGetTodosConveniadosQuery,
  useGetConveniadosPorOrgaoQuery,
  useGetConveniadosQuery,
  useUpdateConveniadosMutation,
  useAddAgenteOrgaosMutation,
  useGetOrgaosParaAgenteQuery,
  useGetOrgaosListQuery,
  useUpdateOrgaoMutation,
  useAddAgenteConveniadosMutation,
  useGetOrgaosConveniadosQuery,
  useEditVeiculoMutation,
  useEditHabilitacaoMutation,
  useRemoveAgenteOrgaosMutation,
  useRemoveOrgaoConveniadosMutation,
  useGetGrvsQuery,
  useGetDetalhesSinaisNotoriosQuery,
  useGetDetalhesBoletimSinistroQuery,
  useGetSinaisNotoriosQuery,
  useGetDetalhesGrvQuery,
  useGetDetalhesGrdQuery,
  useGetDetalhesMedidaAdministrativaAvulsaQuery,
  useGetTotalAutosAgenteQuery,
  useLazyGetTotalAutosAgenteQuery,
  useLazyGetIncidenciaInfracoesQuery,
  useGetIncidenciaInfracoesQuery,
  useGetAITsDiaAnteriorQuery,
  useGetAITsDiaQuery,
  useGetAITsMesQuery,
  useGetTotalAgentesQuery,
  useGetAITsSemanaQuery,
  useGetAutosErroQuery,
  useGetImpressorasQuery,
  useEditImpressoraMutation,
  useAdicionarImpressoraMutation,
  useAddNovoChipMutation,
  useGetSimCartaoQuery,
  useGetSimCartaoPorIdQuery,
  useEditRemoverCartaoMutation,
  useGetTodosSimCartaoQuery,
  useEditSimCartaoMutation,
  useGetPenalidadeQuery,
  useGetGravidadeQuery,
  useGetConfiguraCrimeTransitoQuery,
  useGetInfratorQuery,
  useGetTipoVeiculoQuery,
  useGetTipoInfracaoQuery,
  useGetInfracoesQuery,
  useGetListaReincidenciasQuery,
  useGetListaReincidenciasRevisadasQuery,
  useGetListaReincidenciasPermitidasQuery,
  useGetAutosInfracaoSemVeiculoQuery,
  useGetAutosInfracaoEstrangeirosQuery,
  useGetAutuacoesPfPjQuery,
  useGetDetalhesInfracaoQuery,
  useGetUsuariosQuery,
  useGetMedidasAdministrativasQuery,
  useGetAgentesQuery,
  useGetOrgaosQuery,
  useEditDispositivoMutation,
  useBloquearDispositivoMutation,
  useDesbloquearDispositivoMutation,
  useGetDispositivoBloqueioLogsQuery,
  useEditEquipamentoMutation,
  useGetLogsAcessoQuery,
  useGetDispositivosQuery,
  useGetDispositivoQuery,
  useGetEquipamentosQuery,
  useAdicionarAgenteMutation,
  useAdicionarUsuarioMutation,
  useAdicionarDispositivoMutation,
  useAdicionarEquipamentoMutation,
  useGetListarFiltroQuery,
  useGetListaFaixaQuery,
  useGetTotalFaixaQuery,
  useGetListaAguardandoCancelamentoQuery,
  useGetListaCanceladosQuery,
  useGetUsuarioQuery,
  useGetUsuariosPorIdQuery,
  useConfirmarCancelamentoMutation,
  useAnularCancelamentoMutation,
  useGetReservaTaloesQuery,
  useGetVeiculoQuery,
  useGetHabilitacaoQuery,
  useGetMedidaAdministrativaInfracaoQuery,
  useGetGrupoInfracaoQuery,
  useGetAssuntosInfracoesQuery,
  useUpdateAssuntoInfracaoMutation,
  useGetArtigoInfracoesQuery,
  useUpdateArtigoInfracaoMutation,
  useGetLegislacaoInfracoesQuery,
  useUpdateLegislacaoInfracaoMutation,
  useGetClientesQuery,
  useUpdateClienteMutation,
  useGetTodosOrgaosDoClienteQuery,
  useGetEscalasQuery,
  useAddEscalaMutation,
  useEditEscalaMutation,
  useDeleteEscalaMutation,
  useGetLogsEscalaQuery,
  useGetMunicipiosQuery,
  useGetStatusAutoQuery,
  useGetStatusProcessamentoQuery,
  useListarEstadosQuery,
  useListarMunicipioQuery,
  useGetAvisosQuery,
  useGetAvisoPorIdQuery,
  useCriarAvisoMutation,
  useEditarAvisoMutation,
  useDeletarAvisoMutation,
  useSubirImagemAvisoMutation,
  useGetAvisosPorClienteQuery,
  useGetImportanciasAvisosQuery,
  useVincularClientesAvisoMutation,
  useGetAvisosVinculadosPorClienteQuery,
  useDesvincularAvisosPorClienteMutation,
  useGetFeedbacksPorClienteQuery,
  useAddFaixaInfracaoMutation,
  useGetOrgaosVinculadosQuery,
  useGetEquipamentosAfericaoQuery,
  useGetEquipamentoAfericaoPorIdQuery,
  useEditEquipamentoAfericaoMutation,
  useAdicionarEquipamentoAfericaoMutation,
  useGetTiposDispositivoQuery,
  useGetAgentesByClienteQuery,
  useGetLogsApisQuery,
  useAtribuirFaixaDispositivoMutation,
  useGetFaixasPorDispositivoQuery,
  useGetTotaisDisponiveisPorOrgaoQuery,
  useGetResumoPorDispositivoQuery,
  useRemoveFaixaDoDispositivoMutation,
  useGetResumoEstoqueQuery,
  useGetEstoqueMovimentacoesQuery,
  useGetEstoqueMovimentacaoQuery,
  useAdicionarEstoqueMovimentacaoMutation,
  useEditarEstoqueMovimentacaoMutation,
  useImportarEstoqueLoteMutation,
  useGetLogsTransporteQuery,
  useGetLogsBiometricosQuery,
  useGetLogsNotificacoesQuery,
  // Notificações
  useGetNotificacoesQuery,
  useGetNotificacaoPorIdQuery,
  useCriarNotificacaoMutation,
  useEditarNotificacaoMutation,
  useDeletarNotificacaoMutation,
  useSubirImagemNotificacaoMutation,
  useVincularAgentesNotificacaoMutation,
  useGetLogsNotificacaoQuery,
  useDesvincularAgenteMutation,
  // FAQ - Dúvidas Frequentes
  useGetDuvidasFrequentesQuery,
  useGetDuvidaFrequentePorIdQuery,
  useCriarDuvidaFrequenteMutation,
  useEditarDuvidaFrequenteMutation,
  useDeletarDuvidaFrequenteMutation,
  useGetVinculosDuvidaQuery,
  useGetArtigosDisponiveisQuery,
  useVincularArtigoDuvidaMutation,
  useDesvincularArtigoDuvidaMutation,
  useGetArtigosQuery,
  useGetArtigoPorIdQuery,
  useCriarArtigoMutation,
  useEditarArtigoMutation,
  useDeletarArtigoMutation,
  useGetDispositivosMesQuery,
  useGetDispositivosNaoUtilizadosMesQuery,
  useGetPainelDispositivosQuery,
  // Novos
  useAddClienteMutation,
  useSubirLogoGestaoClienteMutation,
  useSubirLogoAppClienteMutation,
  useSubirLogoIconeClienteMutation,
  useSubirLogoOrgaoMutation,
  useSubirLogoImpressaoOrgaoMutation,
  useSubirLogoAITOrgaoMutation,
  useGetOrgaoPorIdQuery,
  useGetClientePorIdQuery,
  useVincularOrgaoMutation,
  useDesvincularOrgaoMutation,
  useGetChatsQuery,
  useGetOrgaosVinculadosClienteQuery,
  useGetOrgaosDisponiveisQuery,
  useVincularOrgaoClienteMutation,
  useGetCompetenciasQuery,
  useDesvincularOrgaoClienteMutation,
  // Veículos Embarcados
  useGetVeiculosEmbarcadosQuery,
  useGetVeiculoEmbarcadoPorIdQuery,
  useCriarVeiculoEmbarcadoMutation,
  useEditarVeiculoEmbarcadoMutation,
  useDeletarVeiculoEmbarcadoMutation,
  useImportarCsvVeiculosMutation,
  // Condutores Embarcados
  useGetCondutoresEmbarcadosQuery,
  useGetCondutorEmbarcadoPorIdQuery,
  useCriarCondutorEmbarcadoMutation,
  useEditarCondutorEmbarcadoMutation,
  useDeletarCondutorEmbarcadoMutation,
  useImportarCsvCondutoresMutation,
  // Infrações Embarcadas
  useGetInfracoesEmbarcadasQuery,
  useGetInfracaoEmbarcadaPorIdQuery,
  useCriarInfracaoEmbarcadaMutation,
  useEditarInfracaoEmbarcadaMutation,
  useDeletarInfracaoEmbarcadaMutation,
  useImportarCsvInfracoesMutation,
  // Unidades
  useGetUnidadesQuery,
  useGetUnidadePorIdQuery,
  useAddUnidadeMutation,
  useUpdateUnidadeMutation,
  // Notificações do Painel
  useGetNotificacoesPainelQuery,
  useContarNotificacoesPainelNaoLidasQuery,
  useMarcarNotificacaoPainelComoLidaMutation,
  // Operações
  useGetOperacoesQuery,
  // Tipos de Operação
  useGetTiposOperacaoQuery,
  useGetTipoOperacaoPorIdQuery,
  useCriarTipoOperacaoMutation,
  useAtualizarTipoOperacaoMutation,
  useExcluirTipoOperacaoMutation,
} = api;




